import { render, staticRenderFns } from "./MortgagesComments.vue?vue&type=template&id=57761c7e&"
import script from "./MortgagesComments.vue?vue&type=script&lang=ts&"
export * from "./MortgagesComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports